import { useSelector } from 'react-redux';
import React from 'react';
import { useRequestData } from 'wsm-common-data';
import ContentRows from '../components/ContentRows';
import '../components/Widget.scss';

const Widget = () => {
	const { windowId } = useRequestData();
	const { data } = useSelector((state) => state);
	return <ContentRows data={data} windowId={windowId} />;
};

export default Widget;
